export default {
    TYPES: {
        SALE: 'sale',
        RENT: 'rent',
        SUBSCRIPTION: 'subscription',
        SUBSCRIPTION_CANCEL: 'subscription-cancel',
    },
};
